import { exists } from '../runtime.js';
import { EcdsaValidatorOptionsFromJSON, EcdsaValidatorOptionsToJSON } from './EcdsaValidatorOptions.js';
import { ProviderAgreementFromJSON, ProviderAgreementToJSON } from './ProviderAgreement.js';
import { ProviderEnumFromJSON, ProviderEnumToJSON } from './ProviderEnum.js';
import { ProviderMultichainAccountAbstractionProvidersFromJSON, ProviderMultichainAccountAbstractionProvidersToJSON } from './ProviderMultichainAccountAbstractionProviders.js';
import { SmsCountryCodeFromJSON, SmsCountryCodeToJSON } from './SmsCountryCode.js';

/* tslint:disable */
/**
* @export
* @enum {string}
*/
var ProviderEntryPointVersionEnum;
(function (ProviderEntryPointVersionEnum) {
    ProviderEntryPointVersionEnum["V6"] = "v6";
    ProviderEntryPointVersionEnum["V7"] = "v7";
})(ProviderEntryPointVersionEnum || (ProviderEntryPointVersionEnum = {})); /**
* @export
* @enum {string}
*/
var ProviderKernelVersionEnum;
(function (ProviderKernelVersionEnum) {
    ProviderKernelVersionEnum["V24"] = "v2_4";
    ProviderKernelVersionEnum["V30"] = "v3_0";
    ProviderKernelVersionEnum["V31"] = "v3_1";
})(ProviderKernelVersionEnum || (ProviderKernelVersionEnum = {}));
function ProviderFromJSON(json) {
    return ProviderFromJSONTyped(json);
}
function ProviderFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'provider': ProviderEnumFromJSON(json['provider']),
        'enabledAt': !exists(json, 'enabledAt') ? undefined : (json['enabledAt'] === null ? null : new Date(json['enabledAt'])),
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'clientSecret': !exists(json, 'clientSecret') ? undefined : json['clientSecret'],
        'providerProjectId': !exists(json, 'providerProjectId') ? undefined : json['providerProjectId'],
        'authorizationUrl': !exists(json, 'authorizationUrl') ? undefined : json['authorizationUrl'],
        'redirectUrl': !exists(json, 'redirectUrl') ? undefined : json['redirectUrl'],
        'defaultChainId': !exists(json, 'defaultChainId') ? undefined : json['defaultChainId'],
        'defaultChain': !exists(json, 'defaultChain') ? undefined : json['defaultChain'],
        'keyExportUrl': !exists(json, 'keyExportUrl') ? undefined : json['keyExportUrl'],
        'termsAcceptedByUser': !exists(json, 'termsAcceptedByUser') ? undefined : ProviderAgreementFromJSON(json['termsAcceptedByUser']),
        'scopes': !exists(json, 'scopes') ? undefined : json['scopes'],
        'baseAuthUrl': !exists(json, 'baseAuthUrl') ? undefined : json['baseAuthUrl'],
        'appleKeyId': !exists(json, 'appleKeyId') ? undefined : json['appleKeyId'],
        'appleTeamId': !exists(json, 'appleTeamId') ? undefined : json['appleTeamId'],
        'accountSid': !exists(json, 'accountSid') ? undefined : json['accountSid'],
        'twilioNumber': !exists(json, 'twilioNumber') ? undefined : json['twilioNumber'],
        'enabledCountries': !exists(json, 'enabledCountries') ? undefined : (json['enabledCountries'].map(SmsCountryCodeFromJSON)),
        'entryPointVersion': !exists(json, 'entryPointVersion') ? undefined : json['entryPointVersion'],
        'kernelVersion': !exists(json, 'kernelVersion') ? undefined : json['kernelVersion'],
        'multichainAccountAbstractionProviders': !exists(json, 'multichainAccountAbstractionProviders') ? undefined : (json['multichainAccountAbstractionProviders'].map(ProviderMultichainAccountAbstractionProvidersFromJSON)),
        'ecdsaProviderType': !exists(json, 'ecdsaProviderType') ? undefined : EcdsaValidatorOptionsFromJSON(json['ecdsaProviderType']),
        'createNewAccounts': !exists(json, 'createNewAccounts') ? undefined : json['createNewAccounts'],
    };
}
function ProviderToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'provider': ProviderEnumToJSON(value.provider),
        'enabledAt': value.enabledAt === undefined ? undefined : (value.enabledAt === null ? null : value.enabledAt.toISOString()),
        'clientId': value.clientId,
        'clientSecret': value.clientSecret,
        'providerProjectId': value.providerProjectId,
        'authorizationUrl': value.authorizationUrl,
        'redirectUrl': value.redirectUrl,
        'defaultChainId': value.defaultChainId,
        'defaultChain': value.defaultChain,
        'keyExportUrl': value.keyExportUrl,
        'termsAcceptedByUser': ProviderAgreementToJSON(value.termsAcceptedByUser),
        'scopes': value.scopes,
        'baseAuthUrl': value.baseAuthUrl,
        'appleKeyId': value.appleKeyId,
        'appleTeamId': value.appleTeamId,
        'accountSid': value.accountSid,
        'twilioNumber': value.twilioNumber,
        'enabledCountries': value.enabledCountries === undefined ? undefined : (value.enabledCountries.map(SmsCountryCodeToJSON)),
        'entryPointVersion': value.entryPointVersion,
        'kernelVersion': value.kernelVersion,
        'multichainAccountAbstractionProviders': value.multichainAccountAbstractionProviders === undefined ? undefined : (value.multichainAccountAbstractionProviders.map(ProviderMultichainAccountAbstractionProvidersToJSON)),
        'ecdsaProviderType': EcdsaValidatorOptionsToJSON(value.ecdsaProviderType),
        'createNewAccounts': value.createNewAccounts,
    };
}

export { ProviderEntryPointVersionEnum, ProviderFromJSON, ProviderFromJSONTyped, ProviderKernelVersionEnum, ProviderToJSON };
